

import QuotationHeader from "./QuotationHeader";
import QuotationBasicInfo from "./QuotationBasicInfo";
import QuotationServicesTable from "./QuotationServicesTable";
import QuotationVendorsTable from "./QuotationVendorsTable";
import QuotationFinancialSummary from "./QuotationFinancialSummary";
import QuotationAdditionalDetails from "./QuotationAdditionalDetails";
import QuotationActions from "./QuotationActions";

interface Quotation {
  id: number;
  quotation_number: string;
  client_id: number;
  client?: { id: number; name: string; email?: string; phone?: string };
  event_name?: string;
  event_type?: string;
  guests?: number;
  guest_count?: number;
  event_date: string;
  package_id?: number;
  package?: { id: number; name: string };
  venue?: string;
  venue_id?: number;
  items?: any[];
  quotation_services?: any[];
  vendors_data?: any[];
  quotation_vendors?: any[];
  subtotal: number;
  discount_type: 'fixed' | 'percentage';
  discount_value: number;
  tax: number;
  total: number;
  notes?: string;
  status?: string;
  valid_until?: string;
}

interface QuotationDetailContentProps {
  quotation: Quotation;
  logoUrl?: string;
  businessName: string;
  isStaff: boolean;
  onDownloadPDF: () => void;
  onUpdateStatus: () => void;
  onConvertToEvent: () => void;
  onEdit: () => void;
  onBack: () => void;
}

export default function QuotationDetailContent({
  quotation,
  logoUrl,
  businessName,
  isStaff,
  onDownloadPDF,
  onUpdateStatus,
  onConvertToEvent,
  onEdit,
  onBack,
}: QuotationDetailContentProps) {
  return (
    <div className="max-w-6xl mx-auto px-4 py-6 space-y-6">
      {/* Header */}
      <QuotationHeader
        quotationNumber={quotation.quotation_number}
        clientName={quotation.client?.name}
        eventType={quotation.event_type}
        logoUrl={logoUrl}
        businessName={businessName}
      />

      {/* Basic Information */}
      <QuotationBasicInfo
        clientName={quotation.client?.name}
        eventType={quotation.event_type}
        eventName={quotation.event_name}
        guests={quotation.guests}
        guestCount={quotation.guest_count}
        eventDate={quotation.event_date}
        venue={quotation.venue}
        venueName={quotation.venue}
        validUntil={quotation.valid_until}
        status={quotation.status}
      />

      {/* Services */}
      <QuotationServicesTable
        services={quotation.items}
        quotationServices={quotation.quotation_services}
      />

      {/* Vendors */}
      <QuotationVendorsTable
        vendors={quotation.vendors_data}
        quotationVendors={quotation.quotation_vendors}
      />

      {/* Financial Summary */}
      <QuotationFinancialSummary
        subtotal={quotation.subtotal}
        discountType={quotation.discount_type}
        discountValue={quotation.discount_value}
        tax={quotation.tax}
        total={quotation.total}
      />

      {/* Additional Details */}
      <QuotationAdditionalDetails
        notes={quotation.notes}
      />

      {/* Actions */}
      <QuotationActions
        onDownloadPDF={onDownloadPDF}
        onUpdateStatus={onUpdateStatus}
        onConvertToEvent={onConvertToEvent}
        onEdit={onEdit}
        onBack={onBack}
        isStaff={isStaff}
      />
    </div>
  );
}
